module.exports = __webpack_public_path__ + "img/img8.f27f4f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img8.png
// module id = 247
// module chunks = 0